<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.orders.form.confirm_order") }}
    </h4>
    <div class="row">
      <div class="col-6 form-group">
        <label class="col-form-label col-12">{{$t('app.modules.orders.form.orderType')}}</label>
        <div class="col-12">
          <el-select
            class="select-primary"
            size="large"
            filterable
            clearable
            placeholder="Tipo Pedido"
            v-model="tipoPedido"
            value=""
          >
            <el-option
              class="select-primary"
              v-for="(tipo, key) in tiposPedido"
              :value="key"
              :label="tipo"
              :key="key"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-12">
        <label class="col-form-label col-12">*{{$t("app.modules.orders.form.impactSAP")}}</label>
      </div>
    </div>
    <div
      slot="footer"
      style="margin-top: 10px; padding-top: 20px;border-top: outset;"
      class="text-right"
    >
      <n-button class="pull-left" @click.native="cancelar()">{{$t('app.modules.products.buttons.cancel')}}</n-button>
      <n-button native-type="submit" type="primary" @click.native="handleSubmit()">{{$t('app.modules.products.buttons.save')}}</n-button>
    </div>
  </modal>
</template>

<script>

import {getResponse} from "@/util/utilities";

export default {
  name: "ProductDetail",
  data() {
    return {
      modals: {
        classic: false
      },
      idPedido: null,
      tiposPedido: {
        1: "Z100",
        2: "Z500",
        3: "Z600"
      },
      tipoPedido: null
    }
  },
  mounted() {
    EventBus.$on("confirmarPedido", async idPedido => {
      await this.init(idPedido.idPedido);
    });
  },
  methods: {
    async init(idPedido) {
      this.showLoader();
      this.idPedido = idPedido;
      this.closeLoader();
      this.modals.classic = true;
    },
    cancelar() {
      this.tipoPedido = null;
      this.modals.classic = false;
    },
    showLoader(){
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
    },
    closeLoader(){
      this.$swal.close();
    },
    async handleSubmit(){
      const param = {
        idPedido: parseInt(this.idPedido),
        tipoPedido: parseInt(this.tipoPedido)
      };
      if(this.tipoPedido){
        this.showLoader();
        try {
          let orderRequest = await this.$http.put(route("Pedidos/ConfirmarPedido"), param)
          let code = getResponse(orderRequest, null, body => body.code);
          if (code == 200) {
            this.notifyMessage("success", this.$t("app.promps.save_success"));
            this.modals.classic = false;
            EventBus.$emit("confirm-order-success");
          } else {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        } catch (e) {
          console.error(e);
          this.notifyMessage("danger", this.$t("app.promps.error"));
        }
        this.closeLoader();
      }else{
        this.notifyMessage("danger", "Tipo pedido es requerido");
      }
    }
  }
};
</script>

<style scoped>

</style>
